import { omit, values } from 'lodash'

import ALLOWED_METADATA_TREE_OPERATIONS from './allowed-metadata-tree-operations'

const METADATA_TYPES = {
  INGREDIENTS: {
    value: 'INGREDIENTS',
    valueSingular: 'INGREDIENT',
    label: 'Ingredients',
    labelSingular: 'Ingredient',
    key: 'ingredients',
    allowedOperations: values(
      omit(ALLOWED_METADATA_TREE_OPERATIONS, [
        ALLOWED_METADATA_TREE_OPERATIONS.SKIP_SET_IS_CURATION_ENABLED,
      ]),
    ),
  },
  DISH_TYPES: {
    value: 'DISH_TYPES',
    valueSingular: 'DISH_TYPE',
    label: 'Dish Types',
    labelSingular: 'Dish Type',
    key: 'dishTypes',
    allowedOperations: values(
      omit(ALLOWED_METADATA_TREE_OPERATIONS, [
        ALLOWED_METADATA_TREE_OPERATIONS.SKIP_SET_IS_CURATION_ENABLED,
      ]),
    ),
  },
  COURSE_TYPES: {
    value: 'COURSE_TYPES',
    valueSingular: 'COURSE_TYPE',
    label: 'Course Types',
    labelSingular: 'Course Type',
    key: 'courseTypes',
    allowedOperations: values(
      omit(ALLOWED_METADATA_TREE_OPERATIONS, [
        ALLOWED_METADATA_TREE_OPERATIONS.SKIP_SET_IS_CURATION_ENABLED,
      ]),
    ),
  },
  CUISINE_TYPES: {
    value: 'CUISINE_TYPES',
    valueSingular: 'CUISINE_TYPE',
    label: 'Cuisine Types',
    labelSingular: 'Cuisine Type',
    key: 'cuisineTypes',
    allowedOperations: values(
      omit(ALLOWED_METADATA_TREE_OPERATIONS, [
        ALLOWED_METADATA_TREE_OPERATIONS.SKIP_SET_IS_CURATION_ENABLED,
      ]),
    ),
  },
  AWARDS: {
    value: 'AWARDS',
    valueSingular: 'AWARD',
    label: 'Awards',
    labelSingular: 'Award',
    key: 'awards',
    allowedOperations: values(
      omit(ALLOWED_METADATA_TREE_OPERATIONS, [
        ALLOWED_METADATA_TREE_OPERATIONS.SKIP_SET_IS_CURATION_ENABLED,
      ]),
    ),
  },
  LOCATION_TYPE_CATEGORIES: {
    value: 'LOCATION_TYPE_CATEGORIES',
    valueSingular: 'LOCATION_TYPE_CATEGORY',
    label: 'Location Type Categories',
    labelSingular: 'Location Type Category',
    key: 'locationTypeCategories',
    allowedOperations: [
      ALLOWED_METADATA_TREE_OPERATIONS.ADD_ROOT,
      ALLOWED_METADATA_TREE_OPERATIONS.ADD_CHILD,
      ALLOWED_METADATA_TREE_OPERATIONS.DELETE,
      ALLOWED_METADATA_TREE_OPERATIONS.RENAME,
      ALLOWED_METADATA_TREE_OPERATIONS.MOVE_TO,
      ALLOWED_METADATA_TREE_OPERATIONS.SET_IS_CURATION_ENABLED,
    ],
  },
  LOCATION_TYPES: {
    value: 'LOCATION_TYPES',
    valueSingular: 'LOCATION_TYPE',
    label: 'Location Types',
    labelSingular: 'Location Type',
    key: 'locationTypes',
    allowedOperations: [
      ALLOWED_METADATA_TREE_OPERATIONS.DELETE,
      ALLOWED_METADATA_TREE_OPERATIONS.RENAME,
      ALLOWED_METADATA_TREE_OPERATIONS.SET_IS_CURATION_ENABLED,
      ALLOWED_METADATA_TREE_OPERATIONS.MOVE,
    ],
  },
  DIET_CATEGORIES: {
    value: 'DIET_CATEGORIES',
    valueSingular: 'DIET_CATEGORY',
    label: 'Diet Categories',
    labelSingular: 'Diet Category',
    key: 'dietCategories',
    allowedOperations: [
      ALLOWED_METADATA_TREE_OPERATIONS.ADD_ROOT,
      ALLOWED_METADATA_TREE_OPERATIONS.ADD_CHILD,
      ALLOWED_METADATA_TREE_OPERATIONS.RENAME,
      ALLOWED_METADATA_TREE_OPERATIONS.MOVE_TO,
      ALLOWED_METADATA_TREE_OPERATIONS.SKIP_SET_IS_CURATION_ENABLED,
      ALLOWED_METADATA_TREE_OPERATIONS.SET_IS_CURATION_ENABLED,
    ],
  },
  DIETS: {
    value: 'DIETS',
    valueSingular: 'DIET',
    label: 'Diets',
    labelSingular: 'Diet',
    key: 'diets',
    allowedOperations: [
      ALLOWED_METADATA_TREE_OPERATIONS.RENAME,
      ALLOWED_METADATA_TREE_OPERATIONS.SET_IS_CURATION_ENABLED,
      ALLOWED_METADATA_TREE_OPERATIONS.MOVE,
      ALLOWED_METADATA_TREE_OPERATIONS.REPLACE,
    ],
  },
  ALLERGENS: {
    value: 'ALLERGENS',
    valueSingular: 'ALLERGEN',
    label: 'Allergens',
    labelSingular: 'Allergen',
    key: 'allergens',
    allowedOperations: [
      ALLOWED_METADATA_TREE_OPERATIONS.ADD_ROOT,
      ALLOWED_METADATA_TREE_OPERATIONS.RENAME,
      ALLOWED_METADATA_TREE_OPERATIONS.SET_IS_CURATION_ENABLED,
    ],
  },
  DICTIONARY_WORDS: {
    value: 'DICTIONARY_WORDS',
    valueSingular: 'DICTIONARY_WORD',
    label: 'Dictionary Words',
    labelSingular: 'Dictionary Word',
    key: 'dictionaryWords',
  },
  CHALLENGES: {
    value: 'CHALLENGES',
    valueSingular: 'CHALLENGE',
    label: 'Challenges',
    labelSingular: 'Challenge',
    key: 'challenges',
    allowedOperations: [
      ALLOWED_METADATA_TREE_OPERATIONS.ADD_ROOT,
      ALLOWED_METADATA_TREE_OPERATIONS.RENAME,
      ALLOWED_METADATA_TREE_OPERATIONS.DELETE,
      ALLOWED_METADATA_TREE_OPERATIONS.SKIP_SET_IS_CURATION_ENABLED,
    ],
  },
  FOOD_MOODS: {
    value: 'FOOD_MOODS',
    valueSingular: 'FOOD_MOOD',
    label: 'Food Moods',
    labelSingular: 'Food Mood',
    key: 'foodMoods',
    allowedOperations: [
      ALLOWED_METADATA_TREE_OPERATIONS.ADD_ROOT,
      ALLOWED_METADATA_TREE_OPERATIONS.RENAME,
      ALLOWED_METADATA_TREE_OPERATIONS.DELETE,
      ALLOWED_METADATA_TREE_OPERATIONS.SKIP_SET_IS_CURATION_ENABLED,
    ],
  },
}

export default METADATA_TYPES
